import Vue from 'vue'
import Router from 'vue-router'
import HomeView from '../views/home.vue'
import RobotSpecView from '../views/robot/spec.vue'
import Robot2sView from '../views/robot/2s/index.vue'
import Robot2sInfoView from '../views/robot/2s/info.vue'
import Robot2sDesignView from '../views/robot/2s/design.vue'
import Robot3View from '../views/robot/3/index.vue'
import Robot3InfoView from '../views/robot/3/info.vue'
import Robot3DesignView from '../views/robot/3/design.vue'
import Robot3sView from '../views/robot/3s/index.vue'
import Robot3sInfoView from '../views/robot/3s/info.vue'
import Robot3sDesignView from '../views/robot/3s/design.vue'
import AboutView from '../views/about.vue'
import NewsView from '../views/news.vue'
import ServiceView from '../views/service.vue'
Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

export default new Router({
  scrollBehavior,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: HomeView,
      meta: { scrollToTop: true }
    },
    {
      path: '/robot2s',
      component: Robot2sView,
      meta: { scrollToTop: true },
      children: [
        {
          path: '',
          component: Robot2sInfoView
        },
        {
          path: 'info',
          component: Robot2sInfoView
        },
        {
          path: 'design',
          component: Robot2sDesignView
        },
        {
          path: 'spec',
          component: RobotSpecView,
        }
      ]
    },
    {
      path: '/robot3',
      component: Robot3View,
      meta: { scrollToTop: true },
      children: [
        {
          path: '',
          component: Robot3InfoView
        },
        {
          path: 'info',
          component: Robot3InfoView
        },
        {
          path: 'design',
          component: Robot3DesignView
        },
        {
          path: 'spec',
          component: RobotSpecView,
        },
      ]
    },
    {
      path: '/robot3s',
      component: Robot3sView,
      meta: { scrollToTop: true },
      children: [
        {
          path: '',
          component: Robot3sInfoView
        },
        {
          path: 'info',
          component: Robot3sInfoView
        },
        {
          path: 'design',
          component: Robot3sDesignView
        },
        {
          path: 'spec',
          component: RobotSpecView,
        }
      ]
    },
    {
      path: '/about',
      name: 'about',
      component: AboutView,
    },
    {
      path: '/news',
      name: 'news',
      component: NewsView,
      meta: { scrollToTop: true }
    },
    {
      path: '/service',
      name: 'service',
      component: ServiceView,
    },
    {
      path: '/robot2s',
      redirect: '/robot2s/info'
    },
    {
      path: '/robot3',
      redirect: '/robot3/info'
    },
    {
      path: '*',
      redirect: '/home'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js